<template>
  <div>
    <vxe-grid
      ref="listingTable"
      size="small"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:sellType="{ row }">
        <el-tag
          v-if="row.v_sellType"
          size="mini"
          :type="
            row.sellType === 'B'
              ? ''
              : row.sellType === 'C'
              ? 'warning'
              : 'success'
          "
        >
          {{ row.v_sellType || '未配置' }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.storeSkuStatus === 'Y'
              ? 'success'
              : row.storeSkuStatus === 'S' ||
                row.storeSkuStatus === 'B' ||
                row.storeSkuStatus === 'W'
              ? 'danger'
              : row.storeSkuStatus === 'X'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_storeSkuStatus || '未配置状态' }}
        </el-tag>
      </template>
      <template v-slot:defaultImageUrl="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU：</span><span style="color: #303133">{{ row.hxSkuNo }}</span>
        <br />
        <span>BRAND：{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:displayFactory="{ row }">
        <span>NC：{{ row.ncNo }}</span>
        <br />
        <span>{{ row.scmName }}</span>
      </template>
      <template v-slot:displayChannel="{ row }">
        <div>
          <span>{{ row.salesTitle }}</span>
        </div>
        <span>
          {{ $l('INDEX.form_label_channelItemNo') || '渠道Item号' }}：
        </span>
        <span style="color: #409EFF">{{ row.channelItemNo }}</span>
        <br />
        <span>{{ $l('INDEX.form_label_channelEanNo') || '渠道条码号' }}：</span>
        <span style="color: #409EFF">{{ row.channelEanNo }}</span>
        <div>
          <span>METHOD：</span>
          <el-tag
            v-if="row.v_hxSellType"
            size="mini"
            :type="
              row.hxSellType === 'B'
                ? ''
                : row.hxSellType === 'C'
                ? 'warning'
                : 'success'
            "
          >
            {{ row.v_hxSellType || '未配置' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:displayPlatformName="{ row }">
        <span>{{ $l('INDEX.table_label_channel_name') || '渠道名称' }}：</span>
        <span style="color: #303133">{{ row.platformName }}</span>
        <br />
        <span>BRAND：</span>
        <span style="color: #303133">{{ row.platformBrandName }}</span>
        <br />
        <span>{{ $l('INDEX.form_label_sale_platform') || '销售渠道' }}：</span>
        <span style="color: #303133">{{ row.v_platformType }}</span>
        <br />
        <span>{{ $l('INDEX.form_label_sellableEach') || '最小出货' }}：</span>
        <span style="color: #409EFF">
          {{ row.sellableEachQty }} / {{ row.sellableEachUnitText }}
        </span>
        <div>
          <span>STATUS：</span>
          <el-tag
            size="mini"
            :type="
              row.hxSkuPlatformStatus === 'Y'
                ? 'success'
                : row.hxSkuPlatformStatus === 'S' ||
                  row.hxSkuPlatformStatus === 'B' ||
                  row.hxSkuPlatformStatus === 'W'
                ? 'danger'
                : row.hxSkuPlatformStatus === 'X'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_hxSkuPlatformStatus || '未配置状态' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'edit':
        case 'detail':
          this.$emit('openEdit', { type: menuType, data })
          break
        case 'available':
          this.$emit('available', data)
          break
        case 'unsaleable':
          this.$emit('unsaleable', data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    onCheckboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
    // 避免点击操作列也会选择行
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'defaultImageUrl', 'col-opt']
      if (filterColumns.includes(property)) return

      const $listingTable = this.$refs.listingTable
      $listingTable.toggleCheckboxRow(row)
      const data = $listingTable.getCheckboxRecords(true)
      this.$emit('checkboxChange', data)
    },
  },
}
</script>
